// eslint-ignore
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck - third party script
export default defineNuxtPlugin(() => {
  if (import.meta.env.VITE_ENV === 'dev') {
    return
  }

  (function (apiKey) {
    (function (p, e, n, d, o) {
      let v, w, x, y, z
      o = p[d] = p[d] || {}
      o._q = o._q || []
      v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'] // eslint-disable-line prefer-const
      for (w = 0, x = v.length; w < x; ++w) (function (m) {
        o[m] = o[m] || function () {
          o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(rest, 0)))
        }
      })(v[w])
      y = e.createElement(n) // eslint-disable-line prefer-const
      y.async = !0
      y.src = 'https://cdn.eu.pendo.io/agent/static/' + apiKey + '/pendo.js'
      z = e.getElementsByTagName(n)[0] // eslint-disable-line prefer-const
      z.parentNode.insertBefore(y, z)
    })(window, document, 'script', 'pendo')
  })('ee678d9d-6aff-421a-6a81-cee00f1d4f4a')
})
